import React from "react";
import { Autocomplete, TextField } from "@mui/material";

/**
 * Reusable organization selector with search/autocomplete
 *
 * @param {Object} userData - User data containing orgs array
 * @param {string} selectedOrg - Currently selected org ID
 * @param {function} onOrgChange - Callback when selection changes
 * @param {boolean} disabled - Whether selector is disabled
 * @param {string[]} excludeOrgs - Array of org IDs to exclude from dropdown
 */
export const OrgSelector = ({
  userData,
  selectedOrg,
  onOrgChange,
  disabled = false,
  excludeOrgs = [],
}) => {
  // Filter out excluded orgs and sort alphabetically
  const availableOrgs = (userData?.orgs?.filter(
    (org) => !excludeOrgs.includes(org.orgID)
  ) || []).sort((a, b) => (a.orgName || "").localeCompare(b.orgName || ""));

  const selectedOption = availableOrgs.find((org) => org.orgID === selectedOrg) || null;

  return (
    <Autocomplete
      id="org-select"
      options={availableOrgs}
      getOptionLabel={(option) => option.orgName || ""}
      value={selectedOption}
      onChange={(_, newValue) => {
        if (newValue) onOrgChange(newValue.orgID);
      }}
      disabled={disabled}
      disableClearable
      sx={{ minWidth: 280, mb: 2.5 }}
      renderInput={(params) => (
        <TextField {...params} placeholder="Search organizations..." variant="outlined" />
      )}
    />
  );
};

export default OrgSelector;
